import React from "react";
import { Text } from "@jsq/ds/core";
import { getFieldTypeLabel } from "../../utils/extensionFieldUtils";
import { ExtensionFieldValueEditor } from "./ExtensionFieldValueEditor";
import * as styles from "./styles_vanilla.css";
import type { ExtensionFieldValueObjectType } from "../../graphql";
import type { EntityExtensionFieldValue } from "../../types";

export type FieldItemProps = {
  fieldValue: EntityExtensionFieldValue;
  onFieldChange: (fieldId: string, value: string) => void;
};

export const FieldItem: React.FC<FieldItemProps> = ({ fieldValue, onFieldChange }) => {
  const field = fieldValue.field;
  const value = fieldValue.value;

  if (!field) {
    return null;
  }

  const fieldTypeLabel = getFieldTypeLabel(field.extensionFieldTypeId);

  return (
    <div key={field.id} className={styles.fieldItemGrid} data-testid={`field-item-${field.id}`}>
      <div className={styles.fieldHeaderGrid}>
        <Text variant="regular-md" className={styles.fieldNameGrid}>
          {field.name}
        </Text>
        <Text variant="regular-sm" className={styles.fieldTypeGrid}>
          {fieldTypeLabel}
        </Text>
      </div>

      <div className={styles.fieldValue}>
        <ExtensionFieldValueEditor
          field={field}
          currentValue={value as ExtensionFieldValueObjectType | null}
          onSave={(newValue) => {
            onFieldChange(field.id, newValue);
            return Promise.resolve();
          }}
        />
      </div>
    </div>
  );
};
